import Vue from 'vue';
import {
    Module,
    VuexModule,
    getModule,
} from 'vuex-module-decorators';
import { EnvironmentPrefix } from '~/interfaces/config.interface';
import store from '~common-store';

@Module({ dynamic: true, store, name: 'config', namespaced: true })
class Config extends VuexModule {

    supportAppNameBase = 'support';

    get baseUrl(): string {
        return process.env.VUE_APP_BASE_URL;
    }

    get appName(): string {
        return process.env.VUE_APP_APP_NAME;
    }

    get apiAdminUrl(): string {
        return process.env.VUE_APP_API_ADMIN_URL;
    }

    get usersManagementUrl(): string {
        return process.env.VUE_APP_USERS_MANAGEMENT_URL;
    }
    get apiAdminSyncUrl(): string {
        return this.apiAdminUsersUrl + '/syncapiadmin';
    }

    get weatherExtractApiUrl(): string {
        return this.apiAdminUsersUrl + '/weatherextractapi';
    }

    get userFlagsApiUrl(): string {
        return this.apiAdminUsersUrl + '/user-flags';
    }

    get apiAdminUsersUrl(): string  {
        return process.env.VUE_APP_API_ADMIN_USERS_URL;
    }

    get defaultApiUrl(): string {
        return `${this.apiAdminUsersUrl}/apiadmin`;
    }

    get supportUrl(): string {
        return `${this.baseUrl}/${this.supportAppNameBase}`;
    }

    get dgmUrl(): string {
        return `${this.baseUrl}/${this.dgmAppNameBase}`;
    }

    get environmentPrefix(): EnvironmentPrefix {
        return process.env.VUE_APP_PREFIX;
    }

    get environment(): string {
        return process.env.VUE_APP_ENV;
    }

    get authCookieName(): string {
        return process.env.VUE_APP_COOKIE_NAME;
    }

    get loginUrl(): string {
        return process.env.VUE_APP_AUTH_URL + '/login';
    }

    get checkLoginUrl(): string {
        return process.env.VUE_APP_USERS_MANAGEMENT_URL + '/auth/redirect';
    }

    get logOutUrl(): string {
        return process.env.VUE_APP_USERS_MANAGEMENT_URL + '/auth/logout';
    }

    get accessToken(): string | null {
        return Vue.$cookies.isKey(this.authCookieName)
            ? Vue.$cookies.get(this.authCookieName)
            : null;
    }

    get dgmAppNameBase() {
        return 'dgm';
    }

    get apiEnvironment(): string {
        return process.env.VUE_APP_API_ENVIRONMENT;
    }
}

export const ConfigModule = getModule(Config);
